export const BOARD_CONFIG = {
    orange: {
        label: 'スクーミーオレンジボード',
        baud: 9600,
        pins: {
            UPPER_LEFT: { first: 18, second: 19, third: 17 },
            UPPER_RIGHT: { first: 14, second: 15, third: 16 },
            LOWER_LEFT: { first: 6, second: 5, third: 3 },
            LOWER_RIGHT: { first: 9, second: 10, third: 2 },
        },
        analogPins: {
            UPPER_LEFT: 'A5',
            UPPER_RIGHT: 'A1',
        },
        analogRes: 1023,
        analogVol: 5.0,
    },
    blue: {
        label: 'スクーミーブルーボード',
        baud: 115200,
        pins: {
            UPPER_LEFT: { first: 17, second: 33, third: 16 },
            UPPER_RIGHT: { first: 22, second: 32, third: 21 },
            LOWER_LEFT: { first: 27, second: 26, third: 25 },
            LOWER_RIGHT: { first: 4, second: 13, third: 14 },
        },
        analogPins: {
            UPPER_LEFT: 'A5',
            UPPER_RIGHT: 'A4',
            LOWER_LEFT: 'A19',
            LOWER_RIGHT: 'A14',
        },
        analogRes: 4095,
        analogVol: 3.3,
    },
} as const;

export type BoardType = keyof typeof BOARD_CONFIG;

export function getInitialCode(board: BoardType): string {
    return `#include <SchooMyUtilities.h>\nSchooMyUtilities scmUtils = SchooMyUtilities();\n\nvoid setup() {\n  Serial.begin(${BOARD_CONFIG[board].baud});\n}\n\nvoid loop() {\n}`;
}

export function getInitialXml(board: BoardType): string {
    const iconSrc = board === 'orange' ? '/images/block/board_orange.svg' : '/images/block/board_blue.svg';

    return `<xml xmlns="https://developers.google.com/blockly/xml">
  <variables>
    <variable type="float" id="preset-i">i</variable>
<variable type="String" id="preset-str">str</variable>
    <variable type="bool" id="preset-flag">flag</variable>
  </variables>
  <block type="schoomy_board" x="20" y="20">
    <field name="BOARD">${board}</field>
    <field name="BOARD_ICON">${iconSrc}</field>
  </block>
</xml>`;
}
